import { TypesStatusListFilter } from '../../data/data-products'

interface OptionsListProps {
    options: TypesStatusListFilter[];
    onSelect: (value: TypesStatusListFilter) => void
    onHide: (value: boolean) => void
}

export default function OptionsList({ options, onSelect, onHide }: OptionsListProps) {
    return (
        <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-300" >
            {options.map((opt) => (
                <li
                    key={opt.id}
                    onClick={() => {
                        onSelect(opt)
                        onHide(false)
                    }}
                    className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px]'
                >
                    {opt.label}
                </li>
            ))}
        </ul>
    )
}
